import { render, staticRenderFns } from "./LocalPosts.vue?vue&type=template&id=5dd9dc6c&scoped=true&"
import script from "./LocalPosts.vue?vue&type=script&lang=js&"
export * from "./LocalPosts.vue?vue&type=script&lang=js&"
import style0 from "./LocalPosts.vue?vue&type=style&index=0&id=5dd9dc6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd9dc6c",
  null
  
)

export default component.exports